import { render } from "./TargetingFilter.vue?vue&type=template&id=28a2cd16"
import script from "./TargetingFilter.vue?vue&type=script&lang=js"
export * from "./TargetingFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__